// Pure eligibility rules for the booking "Options supplémentaires" step.
// Kept framework-free so the rules are unit-testable without rendering the
// component.

export interface OptionEligibilityContext {
  /** venue === 'serre' */
  isGreenhouse: boolean;
  /** 'diner' service quantity (meal headcount; 0 for lodging-only bookings) */
  dinerQuantity: number;
  /** 'logement' service quantity (lodging headcount; 0 for diner-only bookings) */
  logementQuantity: number;
}

// Minimum headcount for the décompte (post-event metered settlement) option.
export const DECOMPTE_MIN_PERSONS = 6;

export function isOptionEligible(id: string, ctx: OptionEligibilityContext): boolean {
  const hasLodging = ctx.logementQuantity > 0;

  if (id === 'chien' || id.includes('brunch')) {
    return hasLodging;
  }
  if (id === 'service') {
    return ctx.isGreenhouse && ctx.dinerQuantity > 6;
  }
  if (id === 'decompte') {
    // Offered for any venue once the booking reaches the minimum headcount,
    // measured as the larger of the meal and lodging counts so diner-only and
    // lodging-only bookings both qualify.
    return Math.max(ctx.dinerQuantity, ctx.logementQuantity) >= DECOMPTE_MIN_PERSONS;
  }
  if (id === 'bainnordique') {
    // Physically in the greenhouse, so only offered for the serre venue.
    return ctx.isGreenhouse;
  }
  return true;
}
